export default __webpack_public_path__ + "static/media/Alert.32fdf498.svg";